import { Component, computed, HostListener, inject } from "@angular/core";
import { Router } from "@angular/router";
import { LucideAngularModule, User } from "lucide-angular";

import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { BreadcrumbService } from "../../../../services/breadcrumbservice.service";
import { SessionService } from "../../../../services/session.service";
import { DropdownItemUifComponent } from "../../../dropdown-item-uif/dropdown-item-uif.component";
import { ALL_NAV_ITEMS } from "../shell-default-uif/nav-item-register";
import { NavDto } from "../shell-default-uif/NavDto";
import { Session } from "../../../../util/Session";
import { HomeRouteDefs } from "../../../../../features/home/routing/HomeRouteDefs";

@Component({
  selector: "app-shell-breadcrumbs-uif",
  imports: [DropdownItemUifComponent, LucideAngularModule, TranslocoDirective],
  templateUrl: "./shell-breadcrumbs-uif.component.html",
  styles: ``,
})
export class ShellBreadcrumbsUifComponent {
  //#region I/O
  showDropdown = false;
  dropdownVisible = false;
  //#endregion  //#region Fields
  //#region Icons
  readonly benutzerIcon = User;
  //#endregion
  translocoService = inject(TranslocoService);
  session = inject(SessionService);
  router = inject(Router);

  initials = computed(() => {
    const benutzer = this.session.getSessionInfo()()?.benutzer;
    return benutzer && benutzer?.vorname?.charAt(0) !== " " && benutzer?.familienname?.charAt(0) !== " "
      ? benutzer?.vorname?.charAt(0) + " " + benutzer?.familienname?.charAt(0)
      : benutzer?.benutzerkennung?.charAt(0) || "";
  });
  userProfileAriaLabel = computed(() => {
    return this.translocoService.translate("shell.breadcrumbs.userProfile", {
      name: this.initials() || this.translocoService.translate("shell.breadcrumbs.user"),
    });
  });
  private internalItems = [...ALL_NAV_ITEMS()];
  navItems = computed(() => {
    const shadowActive = Session.isShadowSession();

    const items =
      this.session.getSessionInfo()()?.benutzer.benutzerTyp === "IdAustria"
        ? this.internalItems.filter(
            (item: NavDto) =>
              item.location === "user-dropdown" && item.route && item.route() !== SessionService.UserChangePwd(),
          )
        : this.internalItems.filter((item: NavDto) => item.location === "user-dropdown");

    // unshadow nur anzeigen, wenn wirklich ein admin_token existiert
    return items.filter((item) => item.name !== "shell.breadcrumbs.userMenu.unshadow" || shadowActive);
  });
  private breadcrumbService = inject(BreadcrumbService);
  breadcrumbs = computed(() => this.breadcrumbService.breadcrumbs());
  //#endregion

  //#region UI Events
  onCrumbClicked(url: string) {
    this.router.navigate([url]);
  }

  toggleUserDropdown() {
    if (this.showDropdown) {
      // First change the animation state
      this.showDropdown = false;

      // Then wait for animation to complete before removing from DOM
      setTimeout(() => {
        this.dropdownVisible = false;
      }, 200);
    } else {
      // For opening, first add to DOM but in hidden state
      this.dropdownVisible = true;

      // Force a browser reflow to ensure the initial state is applied
      // before changing to visible state
      setTimeout(() => {
        this.showDropdown = true;
      }, 10);
    }
  }

  onUserMenuItemClicked(item: NavDto) {
    if (item.name === "shell.breadcrumbs.userMenu.unshadow") {
      Session.returnToAdmin();
      this.session.reloadSessionInfo();

      this.router.navigate([HomeRouteDefs.getFQRHome()]);

      this.toggleUserDropdown();
      return;
    }

    this.toggleUserDropdown();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    // Get the dropdown button and content
    const dropdownButton = document.querySelector(".user-dropdown-btn");
    const dropdownContent = document.querySelector(".user-dropdown-content");

    // Close dropdown if click is outside both the button and content
    if (
      dropdownButton &&
      dropdownContent &&
      !dropdownButton.contains(event.target as Node) &&
      !dropdownContent.contains(event.target as Node) &&
      this.showDropdown
    ) {
      this.toggleUserDropdown();
    }
  }

  //#endregion
}
